import './TermsAndConditions.scss';

function TermsAndConditions() {
    return (
        <section className='terms'>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    COLLECTION OF YOUR INFORMATION
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    We may collect information about you in a variety of ways. The information we may collect on the App includes:
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    Personal Data
                </p>
                <p className='terms__block-writing'>
                    When using our app, as appropriate, you will be asked to enter your credentials or other details to help you with your experience.
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    Derivative Data
                </p>
                <p className='terms__block-writing'>
                    Information our servers automatically collect when you access the App, such as your IP address, your browser type, your operating system, your access times, and the pages you have viewed directly before and after accessing the App.
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    Financial Data
                </p>
                <p className='terms__block-writing'>
                    We do not collect any financial information since all in-app purchases are handled through Google Playstore and Apple App Store. You are encouraged to go through their Privacy Policies to see how they handle your financial information.
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    Mobile Device Data
                </p>
                <p className='terms__block-writing'>
                    Device information, such as your mobile device ID, model, and manufacturer, and information about the location of your device, if you access the App from a mobile device.
                </p>
            </div>

            <div className='terms__block'>
                <p className='terms__block-writing'>
                    Financial Data
                </p>
                <p className='terms__block-writing'>
                    We do not collect any financial information since all in-app purchases are handled through Google Playstore and Apple App Store. You are encouraged to go through their Privacy Policies to see how they handle your financial information.
                </p>
            </div>








        </section>
    )
}

export default TermsAndConditions
